import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	width: 100%;
	gap: ${({ hasNumber }) => (hasNumber ? 'var(--spacing-6)' : '')};
`;

export const Item = styled.div`
	display: flex;
	flex-direction: ${({ alignment }) => (alignment === 'center' ? 'column' : 'row')};
	position: relative;
	@media ${Breakpoints.mobile} {
		gap: ${({ alignment }) => (alignment === 'center' ? '0rem' : '2.5rem')};
	}
`;

export const Separator = styled.div`
	flex: 0 1;
	display: flex;
	flex-direction: column;
	margin: 0 auto;
	min-height: 3rem;
	width: fit-content;
`;

export const SeparatorNoHeight = styled.div`
	min-height: 2rem;
`;

export const Content = styled.div`
	margin: ${({ alignment }) => (alignment === 'center' ? '0 auto' : '0')};
	width: 90%;
	&.reverse {
		justify-content: flex-start;
	}
`;

export const SeparatorLine = styled.div`
	width: 1px;
	border: 1px dashed #bebebe;
	height: 100%;
	min-height: 3rem;
	margin: 0 auto;
`;

export const SeparatorLineNoHeight = styled.div`
	width: 1px;
	border: 1px dashed #bebebe;
	height: 100%;
	min-height: 2rem;
	margin: 0 auto;
`;

export const LineNumber = styled.span`
	font-size: var(--paragraph3-font-size);
	font-weight: 500;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background: var(--black-20);
	border-radius: 50%;
	width: 3.5rem;
	height: 3.5rem;
`;
